import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Layout from "../pages/Layout/Layout";
import ForgotPassword from "../pages/Login/ForgotPassword";
import ChangePassword from "../pages/Login/ChangePassword";
import Login from "../pages/Login/Login";
import Page404 from "../pages/404";

import { validRoles } from "../services/Utils";
import { routes } from "./routes";
import { authLogout } from "../redux/actions/auth.actions";

const AppRouter = (props) => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const roles = user?.roles || [];

	let token = false;
	if (user) {
		token = localStorage.getItem("token");
	} else {
		localStorage.removeItem("user");
		localStorage.removeItem("superuser");
		localStorage.removeItem("token");
		localStorage.removeItem("expiration_date");
		localStorage.removeItem("roles");
	}

	if (localStorage.getItem("VERSION") !== process.env.REACT_APP_VERSION) {
		localStorage.setItem("VERSION", process.env.REACT_APP_VERSION);
		dispatch(authLogout()).then(() => {
			window.location.reload(true);
		});
	}

	return (
		<>
			<BrowserRouter basename="/">
				<Routes>
					<Route path="/acceso/:message?" element={<Login />} />
					<Route path="/recuperar_contrasena" element={<ForgotPassword />} />
					<Route path="/cambiar_contrasena/:token" element={<ChangePassword />} />

					<Route
						path="/*"
						element={
							<Layout>
								<Routes>
									{token ? (
										<>
											{routes.map(({ path, Component, roles: rolesRoute }) => {
												const valid_role = validRoles(roles, rolesRoute);

												return <Route key={path} path={path} element={valid_role ? <Component /> : <Page404 />} />;
											})}
											<Route path="*" element={<Page404 />} />
										</>
									) : (
										<Route path="*" element={<Navigate to="/acceso" state={{ from: props.location }} replace />} />
									)}
								</Routes>
							</Layout>
						}
					/>
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default AppRouter;
